(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["driver-cards-directory"] && !Shopify.designMode) return;
  try {
    
  class DriverDirectory extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.searchInput = this.querySelector('[data-driver-search]');
      this.groupsContainer = this.querySelector('[data-driver-groups]');
      this.emptyMessage = this.querySelector('[data-driver-empty]');
      this.letterLinks = Array.from(this.querySelectorAll('[data-driver-letter]'));
      this.cards = Array.from(this.querySelectorAll('[data-driver-card]'));

      this.buildGroups();
      this.searchInput?.addEventListener('input', () => this.filterCards());
    }

    buildGroups() {
      const groups = new Map();

      this.cards
        .sort((first, second) => first.dataset.driverName.localeCompare(second.dataset.driverName))
        .forEach((card) => {
          const letter = card.dataset.driverName.charAt(0).toUpperCase();
          if (!groups.has(letter)) groups.set(letter, []);
          groups.get(letter).push(card);
        });

      this.letterLinks.forEach((link) => {
        const hasDrivers = groups.has(link.dataset.driverLetter);
        link.setAttribute('aria-disabled', String(!hasDrivers));
        link.tabIndex = hasDrivers ? 0 : -1;
      });

      groups.forEach((cards, letter) => {
        const group = document.createElement('section');
        group.className = 'driver-directory__group';
        group.id = `DriverLetter-${this.dataset.sectionId}-${letter}`;
        group.dataset.driverGroup = letter;

        const heading = document.createElement('h3');
        heading.className = 'driver-directory__group-heading';
        heading.textContent = letter;

        const grid = document.createElement('div');
        grid.className = 'driver-directory__grid';
        cards.forEach((card) => grid.append(card));

        group.append(heading, grid);
        this.groupsContainer.append(group);
      });
    }

    filterCards() {
      const query = this.searchInput.value.trim().toLocaleLowerCase();
      let visibleCards = 0;

      this.querySelectorAll('[data-driver-group]').forEach((group) => {
        let visibleInGroup = 0;

        group.querySelectorAll('[data-driver-card]').forEach((card) => {
          const matches = query === '' || card.dataset.driverName.includes(query);
          card.hidden = !matches;
          if (matches) visibleInGroup += 1;
        });

        group.hidden = visibleInGroup === 0;
        visibleCards += visibleInGroup;
      });

      this.emptyMessage.hidden = visibleCards !== 0;
    }
  }

  if (!customElements.get('driver-directory')) {
    customElements.define('driver-directory', DriverDirectory);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nascar-driver-directory"] && !Shopify.designMode) return;
  try {
    
  class DriverDirectory extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.searchInput = this.querySelector('[data-driver-search]');
      this.groupsContainer = this.querySelector('[data-driver-groups]');
      this.emptyMessage = this.querySelector('[data-driver-empty]');
      this.letterLinks = Array.from(this.querySelectorAll('[data-driver-letter]'));
      this.cards = Array.from(this.querySelectorAll('[data-driver-card]'));

      this.buildGroups();
      this.searchInput?.addEventListener('input', () => this.filterCards());
    }

    buildGroups() {
      const groups = new Map();

      this.cards
        .sort((first, second) => first.dataset.driverName.localeCompare(second.dataset.driverName))
        .forEach((card) => {
          const letter = card.dataset.driverName.charAt(0).toUpperCase();
          if (!groups.has(letter)) groups.set(letter, []);
          groups.get(letter).push(card);
        });

      this.letterLinks.forEach((link) => {
        const hasDrivers = groups.has(link.dataset.driverLetter);
        link.setAttribute('aria-disabled', String(!hasDrivers));
        link.tabIndex = hasDrivers ? 0 : -1;
      });

      groups.forEach((cards, letter) => {
        const group = document.createElement('section');
        group.className = 'driver-directory__group';
        group.id = `DriverLetter-${this.dataset.sectionId}-${letter}`;
        group.dataset.driverGroup = letter;

        const heading = document.createElement('h3');
        heading.className = 'driver-directory__group-heading';
        heading.textContent = letter;

        const grid = document.createElement('div');
        grid.className = 'driver-directory__grid';
        cards.forEach((card) => grid.append(card));

        group.append(heading, grid);
        this.groupsContainer.append(group);
      });
    }

    filterCards() {
      const query = this.searchInput.value.trim().toLocaleLowerCase();
      let visibleCards = 0;

      this.querySelectorAll('[data-driver-group]').forEach((group) => {
        let visibleInGroup = 0;

        group.querySelectorAll('[data-driver-card]').forEach((card) => {
          const matches = query === '' || card.dataset.driverName.includes(query);
          card.hidden = !matches;
          if (matches) visibleInGroup += 1;
        });

        group.hidden = visibleInGroup === 0;
        visibleCards += visibleInGroup;
      });

      this.emptyMessage.hidden = visibleCards !== 0;
    }
  }

  if (!customElements.get('driver-directory')) {
    customElements.define('driver-directory', DriverDirectory);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nce-break-builder-live"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('message',event=>{if(event.origin!=='https://collection.nascardexchange.com'||event.data?.type!=='nce-break-preview-height')return;const frame=[...document.querySelectorAll('[data-nce-break-builder-live]')].find(item=>item.contentWindow===event.source);if(frame&&Number.isFinite(event.data.height))frame.style.height=`${Math.min(30000,Math.max(700,event.data.height))}px`;});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nce-break-preview"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('message',event=>{if(event.origin!=='https://collection.nascardexchange.com'||event.data?.type!=='nce-break-preview-height')return;const frame=[...document.querySelectorAll('[data-nce-break-preview]')].find(item=>item.contentWindow===event.source);if(frame&&Number.isFinite(event.data.height))frame.style.height=`${Math.min(30000,Math.max(700,event.data.height))}px`;});

  } catch(e) { console.error(e); }
})();
})();
